import { render, staticRenderFns } from "./Vendor.vue?vue&type=template&id=0b54ad94"
import script from "./Vendor.vue?vue&type=script&lang=ts"
export * from "./Vendor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports